export const mekiJobAreas = [
    {
        key: 'ettermi-munkatars',
        title: 'Éttermi munkatárs',
        text: 'Munkatársaink a Meki arcai is egyben. Van, hogy a kasszában köszöntik a vendégeket, és van, amikor a legjobb szendvicseket készítik el számukra.',
        image: '/assets/images/meki_job_area_1.jpg',
    },
    {
        key: 'vendegelmeny-manager',
        title: 'Vendégélmény manager',
        text: 'Segítség a vendégnek. A Vendégélmény manager segít a kioszkokon való rendelésben, szükség esetén segít az ételek kiválasztásában, és felügyeli, hogy a vendégtérben minden rendben legyen.',
        image: '/assets/images/meki_job_area_2.jpg',
    },
    {
        key: 'mcafe-munkatars-barista',
        title: 'McCafé munkatárs / Barista',
        text: 'Kávé rajongók terepe, ahol a Barista készíti el a McCafé kávéit, szendvicseit, és felszolgálja a süteményeket.',
        image: '/assets/images/meki_job_area_3.jpg',
    },
    {
        key: 'hostess',
        title: 'Hostess',
        text: 'Az első, hogy a vendég jól érezze magát, amikor betér a Mekibe. A Vendégtér koordinátor ezért felel. Beszélget velük, szervezi a szülinapi partikat, szóróajándékot oszt, és kezeli az ad hoc panaszokat.',
        image: '/assets/images/meki_job_area_4.jpg',
    },
];

export const mekiRolePages = {
    'ettermi-munkatars': {
        ...mekiJobAreas[0],
        heroImage: '/assets/images/meki_job_area_1b.jpg',
        featureImage: '/assets/images/meki_job_area_1a.jpg',
        lead: 'Van, hogy a kasszában köszöntöd a vendégeket, és van, amikor a legjobb szendvicseket készítied el számukra.',
        heading: 'A Meki arcai',
        intro: 'Ez az a diákmunka, ahol soha sem fogsz unatkozni. Minden műszak sajátos légkörben és prögésben telik. Van, hogy a grill állomáson felügyeled a húsokat, máskor a Drive-In rendeléseket veszed fel, esetleg kasszázol vagy segítesz az étterem nyitásában, zárásában.',
        quote: [
            '3 évem alatt sok dolgot tanultam meg a Mekiben, és nem feltétlenül a sajtburger elkészítésére vagy a megfelelő kiszolgálási időre gondolok. Ezen a helyen tanultam meg, mit jelent a munka, az alázat és a csapatszellem. Bár 2017-ben csak a nyár végéig akartam dolgozni, annyira megszerettem, hogy a mai napig itt vagyok.',
            'A mekiben nem csak a munkát látom, hanem az elmúlt évek emlékeit is. Az életem legmeghatározóbb időszakát éltem meg, a pályaválasztástól, az érettségin keresztül, az egyetemi felvételiig, és ebben mindig segítségemre voltak a feletteseim és a munkatársaim.',
            'Itt ismertem meg a legjobb barátaimat. Nem csak azoknak ajánlom a mekis munkát, akik pénzt szeretnének keresni, hanem azoknak is, akik egy igazán jó közösség tagjai szeretnének lenni! :)',
        ],
        quoteName: 'Balogh Dorottya (20), Budapest',
        body: [
            'A csapat szuper, a betanításban mentorok támogatnak, és soha se kell egyedül lenned.',
            'Nagyjából mindent megtanítanak neked, amit egy Mekis csapattagnak tudnia kell, és tényleg rengeteget fejlődhetsz.',
            'Persze vannak betartandó szabályok, hiszen étellel dolgozunk nap mint nap.',
        ],
        closing: 'Ne habozz, próbáld ki magad! Jelentkezz!',
    },
    'vendegelmeny-manager': {
        ...mekiJobAreas[1],
        heroImage: '/assets/images/meki_job_area_2b.jpg',
        featureImage: '/assets/images/meki_job_area_2a.jpg',
        lead: 'A Vendégélmény manager segít a vendégeknek, és felügyeli, hogy a vendégtérben minden rendben legyen.',
        heading: 'A Meki élmény meghatározó alakjai',
        intro: 'Szeretsz az emberekkel beszélgetni, és jó kommunikációs készséggel rendelkezel? Akkor a Vendégélmény manager pozíció jó választás lehet számodra is a Mekis diákmunka lehetőségek közül. Ebben a pozícióban fejlesztheted magad, hogy minden helyzetben barátságos és mindig nyugodt maradj. És biztosak vagyunk benne, hogy ez hatalmas előnyödre válik majd a karrierépítés során.',
        quote: [
            'Vendégélmény manager-nek lenni nagy felelősség, mivel te vagy az étterem arca.',
            'Te vagy az akivel először találkozik a vendég és mind tudjuk, hogy milyen fontosak az első benyomások.',
            'A munkámat leginkább a vendégek teszik felejthetetlenné és miattuk élvezem ennyire. Mindig szerettem emberekkel beszélgetni, új történeteket megismerni és pont emiatt érzem úgy, hogy ez a pozíció nekem lett kitalálva. Persze, a munka nagy felelősséggel jár, amivel én is tanulok.',
            'Ha szereted az embereket és a kihívásokat ez a munka neked való!',
        ],
        quoteName: 'Pribék István (21), Budapest',
        body: [
            'Feladataid közé tartozik a vendégek fogadása és irányítása, valamint a termékekkel és a szolgáltatásokkal kapcsolatos kérdéseik megválaszolása. Felügyeled a vendégteret, hogy mindenki rendezett és tiszta környezetbe fogyaszthassa el rendelését.',
            'Te vagy az, akihez segítségért fordulhatnak, ha nem boldogulnak a kioszkokon történő rendeléssel, és megtaníthatod nekik, hogyan működik az eszköz.',
            'Munkáddal támogatod az étterem vezetőségét is, hiszen ha egy vendég valamivel nem elégedett, te informálhatod a céget, és akár változások elindítója is lehetsz.',
        ],
        closing: 'Szívesen kipróbálnád magad, mint Vendégélmény manager? Ne habozz! Jelentkezz!',
    },
    'mcafe-munkatars-barista': {
        ...mekiJobAreas[2],
        heroImage: '/assets/images/meki_job_area_3b.jpg',
        featureImage: '/assets/images/meki_job_area_3a.jpg',
        lead: 'Kávé rajongók terepe, ahol a Barista készíti el a McCafé kávéit, szendvicseit, és felszolgálja a süteményeket.',
        heading: 'Kávé, kávé, kávé és egy kis süti',
        intro: 'A McCafé munkatárs igazi kávészakértővé válhat. Elsajátíthatod a kávékészítés szabályait, kasszázol, és felszolgálod a süteményeket a vendégeknek. Ha kitartóan dolgozol Barista minősítést szerezhetsz.',
        quote: [
            'Számomra a meki hobbi, kikapcsolódás és - csak végsősoron - munka. 2018-ban kezdtem, csak a nyári szezon volt betervezve, de most már majdnem 2 éve mekizek, és eszemben sincs abbahagyni!',
            'Mindig érdekelt a kávék világa, a McCafénak és a segítőkész vezetőségnek köszönhetően hamar teljesült a vágyam, hogy barista lehessek.',
            'Az egész éttermet kiskorom óta csodáltam, nem véletlen, hogy ma is elképesztő érzés a csodaszép kávézó részen dolgozni. Minden alkalommal ugyanolyan örömmel tölt el felsétálni az emeletre, és beállni a pult mögé, elkészíteni a kedvenc réteges kávéimat.',
            'A Meki kinyitott előttem rengeteg kaput, magabiztosan állva a felnőtt élet előtt, tudván, hogy örömömet lelem a vendéglátásban.',
        ],
        quoteName: 'Gadácsi Zsombor (18), Budapest',
        body: [
            'Bár ez a diákmunka a kávé köré épül, mégis rengeteg dolgot tanulhatsz meg, ami nem csak a kávé iránti szeretetnek tesz jót, hanem a karrierednek is.',
        ],
        closing: 'Rendelhetjük tőled a következő cappucino-t? Jelentkezz!',
    },
    hostess: {
        ...mekiJobAreas[3],
        heroImage: '/assets/images/meki_job_area_4b.jpg',
        featureImage: '/assets/images/meki_job_area_4a.jpg',
        lead: 'Az első, hogy a vendég jól érezze magát, amikor betér a Mekibe. A Vendégtér koordinátor ezért felel.',
        heading: 'Kedvesség, mosoly, segítőkészség',
        intro: 'A Vendégtér koordinátorok feladata, hogy aki betér egy mekizésre, az jól érezze magát. Feladata, hogy beszélgessen velük, sgeítsen nekik a rendelésben, vagy épp megszervezza a szülinapi partikat. Figyel a tisztaságra, a gyerekeknek szóróajándékot ad, és ha szükséges kezeli az ad hoc panaszokat is.',
        quote: [
            'Te vagy az akivel először találkozik a vendég és mind tudjuk, hogy milyen fontosak az első benyomások.',
            'A munkámat leginkább a vendégek teszik felejthetetlenné és miattuk élvezem ennyire. Mindig szerettem emberekkel beszélgetni, új történeteket megismerni és pont emiatt érzem úgy, hogy ez a pozíció nekem lett kitalálva. Persze, a munka nagy felelősséggel jár, amivel én is tanulok.',
            'Ha szereted az embereket és a kihívásokat ez a munka neked való!',
        ],
        quoteName: 'Pribék István (21), Budapest',
        body: [
            'Te vagy az, akihez segítségért fordulhatnak, ha nem boldogulnak a kioszkokon történő rendeléssel, és megtaníthatod nekik, hogyan működik az eszköz.',
            'Munkáddal támogatod az étterem vezetőségét is, hiszen ha egy vendég valamivel nem elégedett, te informálhatod a céget, és akár változások elindítója is lehetsz.',
        ],
        closing: 'Szívesen kipróbálnád magad, mint Vendégélmény manager? Ne habozz! Jelentkezz!',
    },
};
